// Timezone-aware time math that pairs with the canonical Duration parse/format
// (./duration). Elapsed time is the ABSOLUTE difference between the two
// instants, so it is correct across DST transitions and multi-day spans
// (elapsed time, not the visual wall-clock difference). Mirrors the Ruby
// Durations::Duration.between / #add_to behavior.
//
// Wall-clock values are naive "YYYY-MM-DDTHH:mm:ss" strings interpreted in the
// given IANA timezone identifier. CommonJS for Node-test + webpack interop.

const moment = require("moment-timezone");

const WALL_FORMAT = "YYYY-MM-DDTHH:mm:ss";

function instant(wallClock, identifier) {
  if (!wallClock) return null;
  const m = identifier ? moment.tz(wallClock, identifier) : moment(wallClock);
  return m.isValid() ? m : null;
}

// Elapsed seconds between two instants. May be negative when end precedes
// start; returns null when either instant is missing/invalid.
function elapsedSeconds(startWall, startId, endWall, endId) {
  const start = instant(startWall, startId);
  const end = instant(endWall, endId);
  if (!start || !end) return null;

  return end.diff(start, "seconds");
}

// Wall-clock string of (start + seconds), rendered in the end timezone. Returns
// null when start is missing/invalid or seconds is not provided.
function endWallFromStart(startWall, startId, seconds, endId) {
  const start = instant(startWall, startId);
  if (!start || seconds === null || seconds === undefined) return null;

  const end = start.clone().add(seconds, "seconds");
  const rendered = endId ? end.clone().tz(endId) : end;
  return rendered.format(WALL_FORMAT);
}

module.exports = { elapsedSeconds, endWallFromStart, WALL_FORMAT };
